import { EmptyState } from '@myhome/ui/patterns/empty-state';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_shell/jobs')({
  component: Page,
});

function Page() {
  return (
    <div className="flex flex-col gap-5">
      <h1 className="font-heading text-headline font-semibold text-navy-900">Jobs</h1>
      <EmptyState
        title="Jobs"
        description="Job list, filters and the full audit trail arrive with the jobs feature."
      />
    </div>
  );
}
